'use strict';

var nocUtil = require('../../util/noc-util');

module.exports = /*@ngInject*/ ["$rootScope", "$scope", "MonitoringStoreService", "InvestigateStateChangeFactory", "DetailWindowFactory", "LocaleFactory","ProjectService", function TableMonitoringViewController(
    $rootScope,
    $scope,
    MonitoringStoreService,
    InvestigateStateChangeFactory,
    DetailWindowFactory,
    LocaleFactory,
    ProjectService) {

    var vm = this;
    var name = 'table';

    // variable for holding trains data to send to child component 'train-info-table'
    vm.trainsData;

    $scope.isMetricSystem = LocaleFactory.isMetric();

    $scope.$on('unitsChanged', function () {
        $scope.isMetricSystem = LocaleFactory.isMetric();
    });

    init();

    /*
     FUNCTIONS
     */

    var deRegisterTrainsUpdatedListener = $rootScope.$on('trains-updated', function(){
        getTrainsData();
    });

    function getTrainsData() {
        vm.trainsData = MonitoringStoreService.getTrains(ProjectService.getSelectedProjectId());
    }

    function init() {
        $scope.$emit('init-child', name);
        vm.projectId = ProjectService.getSelectedProjectId();
        if (vm.projectId === 0) {
            vm.isIntegratedConsole =  true;
          }
        getTrainsData();
    }

    vm.investigateTrain = function (train) {
        InvestigateStateChangeFactory.investigateInDetail(train);
    };

    vm.openModal = function (train) {  // TODO
        DetailWindowFactory.openModal(train, function (currentTrain) {
            vm.investigate(currentTrain);
        }, function () {
        });
    };

    vm.showInformation = function () {
        $scope.$emit('information-tooltip');
    };

    vm.getLabelClassForLink = function (link) {
        return nocUtil.determineLabelClassForLink(link);
    };

    $scope.$on('$destroy', function () {
        console.log("destrying table")
        deRegisterTrainsUpdatedListener();
        vm.trainsData = undefined;
    });

}];